var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", { d: "M498 253C498 116 388 4 252 4 117 4 7 116 7 253c0 138 110 250 245 250 136 0 246-112 246-250zm-272 37l119-120c14-13 35-13 48 0s13 34 0 48L262 349c-2 2-4 4-7 5-2 3-3 5-6 7-13 14-34 13-48 0l-71-71c-13-14-13-35 0-48s35-13 48 0z" })
  );
});